import React from "react";
import styles from "./index.module.scss";
import editBtn from "../../../../assets/images/edit.png";
import deleteBtn from "../../../../assets/images/deleteBtn.png";
import { formatSeconds } from "../../../../util";

const UsersTable = ({
  currentData,
  usersHashtable,
  handleShowUser,
  editable,
  phoneNumber,
  loading,
  handlePhoneUpdate,
  handleUpdatePhoneNumber,
  handleEditable,
  handleDelete,
}) => {
  return (
    <div className={styles.usersTableWrapper}>
      <table className={styles.usersTable}>
        <thead>
          <tr>
            <th>SNo.</th>
            <th>Name</th>
            <th>Passcode</th>
            <th>Mobile Number</th>
            <th>Total Time Spent (hh:mm:ss)</th>
            <th>Assessment Taken</th>
            <th>Last Assessment</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentData.length > 0 ? (
            currentData.map((user, index) => (
              <tr
                key={index}
                className={user.testTaken === 0 ? styles.disabled : ""}
                onClick={() => handleShowUser(usersHashtable[user.uid])}
              >
                <td data-label="SNo.">{index + 1}</td>
                <td data-label="Name">{user.name}</td>
                <td data-label="Passcode">{user.code}</td>

                <td data-label="Mobile Number">
                  {editable === index && phoneNumber ? (
                    <input
                      value={phoneNumber}
                      onChange={handlePhoneUpdate}
                      className={styles.phoneInput}
                    />
                  ) : (
                    user.phoneNumber
                  )}
                </td>

                <td data-label="Total Time Spent (hh:mm:ss)">
                  {formatSeconds(Math.floor(user.timespent))}
                </td>

                <td data-label="Assessment Taken">{user.testTaken}</td>

                <td data-label="Last Assessment">
                  {user.lastTestStartTimestamp
                    ? new Date(user.lastTestStartTimestamp).toLocaleString()
                    : "-"}
                </td>

                <td
                  data-label="Actions"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className={styles.actionBtns}>
                    {editable === index && phoneNumber ? (
                      <button
                        onClick={() =>
                          handleUpdatePhoneNumber(usersHashtable[user.uid])
                        }
                        className={styles.doneBtn}
                      >
                        {loading ? (
                          <span className={styles.loader} />
                        ) : (
                          "Done"
                        )}
                      </button>
                    ) : (
                      <img
                        src={editBtn}
                        alt="Edit"
                        onClick={() =>
                          handleEditable(usersHashtable[user.uid], index)
                        }
                      />
                    )}

                    <img
                      src={deleteBtn}
                      alt="Delete"
                      className={styles.deleteBtn}
                      onClick={() => handleDelete(usersHashtable[user.uid])}
                    />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className={styles.noUsers}>
                No Users
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UsersTable;

